import { TextInput } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { NAME_MAX_LENGTH } from "@jugl-web/domain-resources/tasks/components/AddNewProductForm/consts";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  register: UseFormRegister<ServiceFormValues>;
  errors: FieldErrors<ServiceFormValues>;
  name: string;
  category: string;
}

export const NameField = ({
  register,
  errors,
  name = "",
  category,
}: ComponentProps) => {
  const { t } = useTranslations();

  const errorMessage =
    name.length > NAME_MAX_LENGTH - 11
      ? `${name.length}/${NAME_MAX_LENGTH}`
      : (errors.name?.message as string | undefined);

  const isService = category === "service";

  return (
    <TextInput
      placeholder={t({
        id: "common.enter",
        defaultMessage: "Enter",
      })}
      {...register("name", {
        maxLength: {
          value: NAME_MAX_LENGTH,
          message: `${name.length}/${NAME_MAX_LENGTH}`,
        },
        setValueAs: (value) => value.trim(),
        required: {
          value: true,
          message: t({
            id: "inventory-item-form-page.mandatory-field",
            defaultMessage: "Mandatory field",
          }),
        },
        validate: (value) => !!value.trim(),
      })}
      isRequired
      isInvalid={!!errors.name}
      label={
        isService
          ? t({
              id: "inventory-item-form-page.service-name",
              defaultMessage: "Service name",
            })
          : t({
              id: "inventory-item-form-page.item-name",
              defaultMessage: "Item name",
            })
      }
      errorMessage={errorMessage}
    />
  );
};
